import { useMutation, useQueryClient } from "react-query";
import { useOkapiKy } from "@folio/stripes/core";
import { previewMessageTemplate, resetMessageTemplate, saveMessageTemplate, } from "../api/messageTemplateService";
import { libraryMessageTemplatesKey } from "./useLibraryMessageTemplates";
export var useSaveMessageTemplate = function (libraryId) {
    var kyInstance = useOkapiKy();
    var queryClient = useQueryClient();
    return useMutation(function (_a) {
        var type = _a.type, payload = _a.payload;
        return saveMessageTemplate(kyInstance, libraryId, type, payload);
    }, {
        onSuccess: function () {
            queryClient.invalidateQueries(libraryMessageTemplatesKey(libraryId));
        },
    });
};
export var useResetMessageTemplate = function (libraryId) {
    var kyInstance = useOkapiKy();
    var queryClient = useQueryClient();
    return useMutation(function (type) {
        return resetMessageTemplate(kyInstance, libraryId, type);
    }, {
        onSuccess: function () {
            queryClient.invalidateQueries(libraryMessageTemplatesKey(libraryId));
        },
    });
};
export var useMessageTemplatePreview = function (libraryId) {
    var kyInstance = useOkapiKy();
    return useMutation(function (payload) {
        return previewMessageTemplate(kyInstance, libraryId, payload);
    });
};
